import { generateEntityName, SadmClient } from '@pixacare/dtos';
import { FormAnswer, FormAnswers } from '@pixacare/forms';
import { isNullOrEmpty } from '@pixacare/shared';
import { SadmEntityDraft } from '@shared/models/draft/sadm-entity-draft';

export const buildSadmEntityDraft = (
  sadmClient: SadmClient,
  {
    patientId,
    clientCode,
    answer,
    fallbackName,
  }: { patientId: number; clientCode: string; answer: FormAnswer; fallbackName: string },
): SadmEntityDraft => {
  const answers: FormAnswers = answer?.answers ?? {};
  const hasAnswers = !isNullOrEmpty(Object.keys(answers));

  return {
    name: hasAnswers ? generateEntityName(sadmClient.entityCreationForm, answers, sadmClient.sadmType) : fallbackName,
    sadmClientId: sadmClient.id,
    patientId,
    clientCode,
    entityCreationFormAnswer: answer?.answers ? answer : { answers: {} },
  };
};
